import { AppAction, AppActionPayload } from './AppModel'

const appUpdate = (payload: AppActionPayload): AppAction => {
  return { type: 'APP_UPDATE', payload }
}

export { appUpdate }
